<template>
  <div class="transition">
    <BasicText
      size="h5"
      class="titre-transition"
    >
      Saisie erronée
    </BasicText>
    <div class="transition-items flex flex-column flex-gap-4">
      <section>
        <BasicText size="body-xl">La saisie semble erronée. Merci de vérifier vos informations.</BasicText>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { BasicText } from '@designSystem/components'
</script>

<style lang="less" scoped>
  .transition-items {
    margin: 36px 0 36px 24px;
  }
</style>

